import './static/css/common.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Row, Col, Button } from 'reactstrap';
import { Form, Input } from 'reactstrap';

const UpdateModal = ({isUpdateModalOpen, setIsUpdateModalOpen, currentItem, changeHandler, handleSubmit, isSaving}) => {
  //console.log("UpdateModal: " + JSON.stringify(currentItem));

  if (!currentItem) return;

  const close = () => { if (!isSaving) setIsUpdateModalOpen(false); };

  return (
    <>
     <Modal size="xl" isOpen={isUpdateModalOpen} toggle={close}>
        <Form onSubmit={handleSubmit}>
        <Input value={currentItem.id} type="hidden" name="id" />
        <ModalHeader toggle={close}>Muokkaa sääntöä</ModalHeader>
        <ModalBody>
        <Row className="margin-bottom-10">
            <Col>Alkuperäinen</Col>
            <Col>Uudelleenohjaus</Col>
            <Col>Tyyppi</Col>
            <Col>Alkaa</Col>
            <Col>Päättyy</Col>
        </Row>     
        <Row>
            <Col><Input value={currentItem.original} onChange={e => changeHandler(e)} type="text" name="original" id="original" /></Col>
            <Col><Input value={currentItem.redirect} onChange={e => changeHandler(e)}  type="text" name="redirect" id="redirect" /></Col>
            <Col><Input value={currentItem.statusCode} onChange={e => changeHandler(e)}  type="select" name="statusCode" id="statusCode">
                <option value="301">Pysyvä (301)</option>
                <option value="302">Väliaikainen (302)</option>
            </Input></Col>
            <Col><Input value={currentItem.startTime} onChange={e => changeHandler(e)}  type="date" id="startTime" name="startTime"/></Col>
            <Col><Input value={currentItem.endTime} onChange={e => changeHandler(e)}  type="date" id="endTime"  name="endTime"/></Col>
        </Row>          
        
        </ModalBody>
        <ModalFooter>
            <Button type="submit" color="primary" disabled={isSaving}>{isSaving ? "Tallennetaan..." : "Tallenna"}</Button>{' '}
            <Button color="secondary" onClick={close} disabled={isSaving}>Peruuta</Button>
        </ModalFooter>
        </Form>
    </Modal>
    </>
  );
}


export default UpdateModal;
